export default "__VITE_ASSET__Cj6YYfVR__"